import { render, staticRenderFns } from "./MmunBlueBenefits.vue?vue&type=template&id=3d18c2de&scoped=true&"
import script from "./MmunBlueBenefits.vue?vue&type=script&lang=js&"
export * from "./MmunBlueBenefits.vue?vue&type=script&lang=js&"
import style0 from "./MmunBlueBenefits.vue?vue&type=style&index=0&id=3d18c2de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d18c2de",
  null
  
)

export default component.exports